import classNames from 'classnames';
import { Spinner } from 'react-bootstrap';
// import LogoLoader from './LogoLoader';
import useLogoLoader from '../../../hooks/useLogoLoader';

const Loader = (props) => {
  const { loader } = useLogoLoader('normal');
  const LogoLoader = loader;
  return (
    <div className={classNames('animated fadeIn pt-3 text-center', props.className)}>
      {props?.logo ? (
        <LogoLoader
          animate={props?.animate}
          animateDuration={props?.animateDuration}
          colors={props?.colors}
        />
      ) : (
        <>
          <Spinner
            as="span"
            animation="border"
            size={props.size || 'lg'}
            role="status"
            variant={props.variant || 'primary'}
            aria-hidden="true"
          />
          <h5 className="mt-2">{!props.hideText && (props.text ? props.text : 'Loading')}</h5>
        </>
      )}
    </div>
  );
};

export default Loader;
